/* ==========================================================================
 * GENERAL INTERACTIONS
 * ========================================================================== */

(function () {
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest(
      '.js-trigger--toggle-filter'
    );

    if (!trigger) return;

    const btn = document.querySelector(
      '.facets-toggle button'
    );
    
    if (btn) btn.click();
  });

  document.addEventListener('click', (e) => {
    const btn = e.target.closest(
      '.js-close-menu--drawer'
    );

    if (!btn) return;

    document
      .querySelector('.header__icon--menu')
      ?.click();
  });
  
  document.addEventListener('DOMContentLoaded', () => {
    const emptyCollection = document.querySelector('.collection--empty');

    if (emptyCollection) {
      const productGridContainer = emptyCollection.closest('.product-grid-container');

      if (productGridContainer) {
        productGridContainer.classList.add('page-width');
      }
    }
  });
})();

/* ==========================================================================
 * PRODUCT MOBILE SLIDER
 * ========================================================================== */

class ProductMobileSlider {
  constructor(root) {
    this.root = root;

    this.track = root.querySelector('.pm-track');
    this.dotsWrap = root.querySelector('.pm-dots');

    this.slides = Array.from(
      root.querySelectorAll('.pm-slide')
    );

    this.realCount = this.slides.length;
    this.index = 1;
    this.animating = false;

    this.lightboxIndex = 0;

    this.setup();
    this.init();

    this.lbIndex = 1;
    this.lbAnimating = false;

    /* Lightbox zoom state */
    this.lbZoomScale = 1;
    this.lbZoomMin = 1;
    this.lbZoomMax = 4;

    this.lbZoomImage = null;

    this.lbPinchStartDistance = 0;
    this.lbPinchStartScale = 1;
    this.lbIsPinching = false;

    this.lbTranslateX = 0;
    this.lbTranslateY = 0;

    this.lbPanStartX = 0;
    this.lbPanStartY = 0;

    this.lbPanOriginX = 0;
    this.lbPanOriginY = 0;

    this.lbIsPanning = false;
    this.lbSwipeStartX = 0;
  }

  /* ------------------------------------------------------------------------
   * Initialize clones and dots
   * --------------------------------------------------------------------- */

  setup() {
    if (this.realCount <= 1) return;

    const first = this.slides[0].cloneNode(true);

    const last =
      this.slides[
        this.slides.length - 1
      ].cloneNode(true);

    first.classList.add('clone');
    last.classList.add('clone');

    this.track.insertBefore(
      last,
      this.slides[0]
    );

    this.track.appendChild(first);

    this.allSlides = Array.from(
      this.track.querySelectorAll('.pm-slide')
    );

    this.createDots();
    this.bindLightboxTriggers();
  }

  init() {
    this.update(false);

    this.track.addEventListener(
      'touchstart',
      this.onStart.bind(this),
      { passive: true }
    );

    this.track.addEventListener(
      'touchend',
      this.onEnd.bind(this),
      { passive: true }
    );

    window.addEventListener(
      'resize',
      () => this.jump()
    );

    this.bindOpenLightboxButton();
    this.bindLightboxNav();
  }

  /* ------------------------------------------------------------------------
   * Lightbox body state
   * --------------------------------------------------------------------- */

  openLightboxSetState() {
    document.body.classList.add('ov_h');
  }

  closeLightboxSetState() {
    document.body.classList.remove('ov_h');
  }

  closeLightbox() {
    this.resetLightboxZoom();

    this.lb.classList.remove(
      'active'
    );

    this.closeLightboxSetState();
  }

  /* ------------------------------------------------------------------------
   * Dots
   * --------------------------------------------------------------------- */

  createDots() {
    if (!this.dotsWrap) return;

    this.dots = [];

    for (
      let i = 0;
      i < this.realCount;
      i++
    ) {
      const dot =
        document.createElement('div');

      dot.className = 'pm-dot';

      dot.addEventListener('click', () => {
        this.goTo(i + 1);
      });

      this.dotsWrap.appendChild(dot);
      this.dots.push(dot);
    }
  }

  updateDots() {
    if (!this.dots) return;

    let realIndex = this.index - 1;

    if (this.index === 0) {
      realIndex = this.realCount - 1;
    }

    if (
      this.index ===
      this.realCount + 1
    ) {
      realIndex = 0;
    }

    this.dots.forEach((dot, i) => {
      dot.classList.toggle(
        'active',
        i === realIndex
      );
    });
  }

  /* ------------------------------------------------------------------------
   * Swipe
   * --------------------------------------------------------------------- */

  onStart(e) {
    this.startX =
      e.touches[0].clientX;
  }

  onEnd(e) {
    const diff =
      this.startX -
      e.changedTouches[0].clientX;

    if (Math.abs(diff) > 40) {
      diff > 0
        ? this.next()
        : this.prev();
    }
  }

  /* ------------------------------------------------------------------------
   * Main slider navigation
   * --------------------------------------------------------------------- */

  next() {
    if (this.animating) return;

    this.index++;
    this.update(true);
  }

  prev() {
    if (this.animating) return;

    this.index--;
    this.update(true);
  }

  goTo(i) {
    this.index = i;
    this.update(true);
  }

  /* ------------------------------------------------------------------------
   * Main slider positioning
   * --------------------------------------------------------------------- */

  update(animate = true) {
    if (!this.track) return;

    this.animating = true;

    this.track.style.transition =
      animate
        ? 'transform 0.35s ease'
        : 'none';

    this.track.style.transform =
      `translate3d(-${
        this.index * 100
      }%, 0, 0)`;

    this.updateDots();

    clearTimeout(this._t);

    this._t = setTimeout(() => {
      if (this.index === 0) {
        this.index =
          this.realCount;

        this.jump();
      }

      if (
        this.index ===
        this.realCount + 1
      ) {
        this.index = 1;
        this.jump();
      }

      this.animating = false;
    }, 350);
  }

  jump() {
    this.track.style.transition =
      'none';

    this.track.style.transform =
      `translate3d(-${
        this.index * 100
      }%, 0, 0)`;
  }

  /* ------------------------------------------------------------------------
   * Lightbox triggers
   * --------------------------------------------------------------------- */

  bindLightboxTriggers() {
    this.slides.forEach(
      (slide, i) => {
        slide.addEventListener(
          'click',
          (e) => {
            if (
              e.target.closest(
                'button, a'
              )
            ) {
              return;
            }

            this.openLightbox(i + 1);
          }
        );
      }
    );

    this.ensureLightbox();
  }

  /* ------------------------------------------------------------------------
   * Lightbox arrows
   * --------------------------------------------------------------------- */

  bindLightboxNav() {
    if (
      !this.lbPrev ||
      !this.lbNext
    ) {
      return;
    }

    this.lbPrev.addEventListener(
      'click',
      (e) => {
        e.preventDefault();

        if (this.lbAnimating) return;

        this.lbAnimating = true;
        this.lbIndex--;

        this.updateLightbox();

        setTimeout(() => {
          this.lbAnimating = false;
        }, 300);
      }
    );

    this.lbNext.addEventListener(
      'click',
      (e) => {
        e.preventDefault();

        if (this.lbAnimating) return;

        this.lbAnimating = true;
        this.lbIndex++;

        this.updateLightbox();

        setTimeout(() => {
          this.lbAnimating = false;
        }, 300);
      }
    );
  }

  /* ------------------------------------------------------------------------
 * Lightbox thumbnails
 * --------------------------------------------------------------------- */

  bindLightboxThumbnails() {
    if (!this.lbThumbnails?.length) {
      return;
    }

    this.lbThumbnails.forEach(
      (thumbnail) => {
        thumbnail.addEventListener(
          'click',
          (e) => {
            e.preventDefault();

            if (this.lbAnimating) {
              return;
            }

            const index = Number(
              thumbnail.dataset
                .lightboxThumbnail
            );

            if (!index) return;
            if (this.lbIndex === index) {
              return;
            }

            this.lbAnimating = true;
            this.lbIndex = index;

            this.updateLightbox();

            setTimeout(() => {
              this.lbAnimating = false;
            }, 300);
          }
        );
      }
    );
  }

  updateActiveLightboxThumbnail(
    animate = true
  ) {
    if (!this.lbThumbnails?.length) {
      return;
    }

    let activeIndex =
      this.lbIndex;

    if (this.lbIndex === 0) {
      activeIndex =
        this.slides.length;
    }

    if (
      this.lbIndex ===
      this.slides.length + 1
    ) {
      activeIndex = 1;
    }

    this.lbThumbnails.forEach(
      (thumbnail) => {
        const thumbnailIndex =
          Number(
            thumbnail.dataset
              .lightboxThumbnail
          );

        const isActive =
          thumbnailIndex ===
          activeIndex;

        thumbnail.classList.toggle(
          'active',
          isActive
        );

        thumbnail.setAttribute(
          'aria-current',
          isActive
            ? 'true'
            : 'false'
        );
      }
    );

    const activeThumbnail =
      this.lbThumbnails.find(
        (thumbnail) => {
          return (
            Number(
              thumbnail.dataset
                .lightboxThumbnail
            ) === activeIndex
          );
        }
      );

    activeThumbnail?.scrollIntoView({
      behavior: animate
        ? 'smooth'
        : 'auto',
      block: 'nearest',
      inline: 'nearest'
    });
  }

  /* ------------------------------------------------------------------------
   * Create or find lightbox
   * --------------------------------------------------------------------- */

  ensureLightbox() {
    const lightboxId =
      this.root.dataset.lightboxId;

    if (!lightboxId) return;

    this.lb =
      document.getElementById(
        lightboxId
      );

    if (!this.lb) return;

    this.lbTrack =
      this.lb.querySelector(
        '.pm-lightbox__track'
      );

    this.lbPrev =
      this.lb.querySelector(
        '.pm-lightbox__nav--prev'
      );

    this.lbNext =
      this.lb.querySelector(
        '.pm-lightbox__nav--next'
      );

    this.lbThumbnails = Array.from(
      this.lb.querySelectorAll(
        '[data-lightbox-thumbnail]'
      )
    );

    this.bindLightboxEvents();
    this.bindLightboxThumbnails();
  }

  /* ------------------------------------------------------------------------
   * Open lightbox
   * --------------------------------------------------------------------- */

  openLightbox(index = 1) {
    this.openLightboxSetState();

    this.lbIndex = index;

    this.lb.classList.add('active');
    this.lbTrack.innerHTML = '';

    const slides = this.slides
      .map((slide) => {
        const img =
          slide.querySelector('img');

        if (!img) return null;

        const wrap =
          document.createElement('div');

        wrap.className =
          'pm-lightbox__slide';

        wrap.appendChild(
          img.cloneNode(true)
        );

        return wrap;
      })
      .filter(Boolean);

    const first =
      slides[0].cloneNode(true);

    const last =
      slides[
        slides.length - 1
      ].cloneNode(true);

    first.classList.add('clone');
    last.classList.add('clone');

    this.lbTrack.appendChild(last);

    slides.forEach((slide) => {
      this.lbTrack.appendChild(slide);
    });

    this.lbTrack.appendChild(first);

    this.lbSlides = Array.from(
      this.lbTrack.querySelectorAll(
        '.pm-lightbox__slide'
      )
    );

    this.updateLightbox(false);
  }

  /* ------------------------------------------------------------------------
   * Update lightbox position
   * --------------------------------------------------------------------- */

  updateLightbox(animate = true) {
    this.resetLightboxZoom();
    this.lbTrack.style.transition =
      animate
        ? 'transform 0.3s ease'
        : 'none';

    this.lbTrack.style.transform =
      `translate3d(-${
        this.lbIndex * 100
      }%, 0, 0)`;

    this.updateActiveLightboxThumbnail(
      animate
    );

    clearTimeout(this._lbFix);

    this._lbFix = setTimeout(() => {
      const count =
        this.slides.length;

      if (this.lbIndex === 0) {
        this.lbIndex = count;

        this.jumpLightbox();

        this.updateActiveLightboxThumbnail(
          false
        );
      }

      if (
        this.lbIndex ===
        count + 1
      ) {
        this.lbIndex = 1;

        this.jumpLightbox();

        this.updateActiveLightboxThumbnail(
          false
        );
      }
    }, 300);
  }

  jumpLightbox() {
    this.lbTrack.style.transition =
      'none';

    this.lbTrack.style.transform =
      `translate3d(-${
        this.lbIndex * 100
      }%, 0, 0)`;
  }

  /* ------------------------------------------------------------------------
   * Dedicated lightbox button
   * --------------------------------------------------------------------- */

  bindOpenLightboxButton() {
    const btn =
      this.root.querySelector(
        '.pm-open-lightbox'
      );

    if (!btn) return;

    btn.addEventListener(
      'click',
      (e) => {
        e.preventDefault();
        e.stopPropagation();

        this.openLightbox(
          this.index
        );
      }
    );
  }

  /* ------------------------------------------------------------------------
 * Lightbox pinch zoom
 * --------------------------------------------------------------------- */

  getLightboxTouchDistance(
    touches
  ) {
    const deltaX =
      touches[0].clientX -
      touches[1].clientX;

    const deltaY =
      touches[0].clientY -
      touches[1].clientY;

    return Math.hypot(
      deltaX,
      deltaY
    );
  }

  getActiveLightboxImage() {
    return this.lbSlides?.[
      this.lbIndex
    ]?.querySelector('img');
  }

  clampLightboxZoom(
    value,
    min,
    max
  ) {
    return Math.min(
      Math.max(value, min),
      max
    );
  }

  applyLightboxZoom() {
    if (!this.lbZoomImage) return;

    this.lbZoomImage.style.transform =
      `translate3d(
        ${this.lbTranslateX}px,
        ${this.lbTranslateY}px,
        0
      ) scale(${this.lbZoomScale})`;
  }

  clampLightboxPosition() {
    if (!this.lbZoomImage) return;

    const imageWidth =
      this.lbZoomImage.clientWidth;

    const imageHeight =
      this.lbZoomImage.clientHeight;

    const maxX =
      Math.max(
        0,
        (
          imageWidth *
          (this.lbZoomScale - 1)
        ) / 2
      );

    const maxY =
      Math.max(
        0,
        (
          imageHeight *
          (this.lbZoomScale - 1)
        ) / 2
      );

    this.lbTranslateX =
      this.clampLightboxZoom(
        this.lbTranslateX,
        -maxX,
        maxX
      );

    this.lbTranslateY =
      this.clampLightboxZoom(
        this.lbTranslateY,
        -maxY,
        maxY
      );
  }

  resetLightboxZoom(
    animate = false
  ) {
    if (this.lbZoomImage) {
      this.lbZoomImage.style.transition =
        animate
          ? 'transform 0.25s ease'
          : 'none';

      this.lbZoomImage.style.transform =
        '';
    }

    this.lbZoomScale =
      this.lbZoomMin;

    this.lbTranslateX = 0;
    this.lbTranslateY = 0;

    this.lbPinchStartDistance = 0;
    this.lbPinchStartScale = 1;

    this.lbIsPinching = false;
    this.lbIsPanning = false;

    this.lbZoomImage = null;
  }

  /* ------------------------------------------------------------------------
   * Lightbox close, swipe, pinch and pan events
   * --------------------------------------------------------------------- */

  bindLightboxEvents() {
    this.lb.addEventListener(
      'click',
      (e) => {
        if (
          e.target.classList.contains(
            'pm-lightbox__overlay'
          ) ||
          e.target.classList.contains(
            'pm-lightbox__close'
          )
        ) {
          //this.resetLightboxZoom();

          this.closeLightbox();
        }
      }
    );

    this.lbTrack.addEventListener(
      'touchstart',
      (e) => {
        /*
        * Start pinch zoom.
        */
        if (e.touches.length === 2) {
          e.preventDefault();

          this.lbZoomImage =
            this.getActiveLightboxImage();

          if (!this.lbZoomImage) return;

          this.lbZoomImage.style.transition =
            'none';

          this.lbIsPinching = true;
          this.lbIsPanning = false;

          this.lbPinchStartDistance =
            this.getLightboxTouchDistance(
              e.touches
            );

          this.lbPinchStartScale =
            this.lbZoomScale;

          return;
        }

        /*
        * Start panning when the image is zoomed.
        */
        if (
          e.touches.length === 1 &&
          this.lbZoomScale > 1
        ) {
          e.preventDefault();

          this.lbZoomImage =
            this.getActiveLightboxImage();

          this.lbIsPanning = true;

          this.lbPanStartX =
            e.touches[0].clientX;

          this.lbPanStartY =
            e.touches[0].clientY;

          this.lbPanOriginX =
            this.lbTranslateX;

          this.lbPanOriginY =
            this.lbTranslateY;

          return;
        }

        /*
        * Start regular slider swipe.
        */
        if (
          e.touches.length === 1
        ) {
          this.lbSwipeStartX =
            e.touches[0].clientX;
        }
      },
      {
        passive: false
      }
    );

    this.lbTrack.addEventListener(
      'touchmove',
      (e) => {
        /*
        * Update pinch zoom.
        */
        if (
          this.lbIsPinching &&
          e.touches.length === 2
        ) {
          e.preventDefault();

          const currentDistance =
            this.getLightboxTouchDistance(
              e.touches
            );

          if (
            !this.lbPinchStartDistance
          ) {
            return;
          }

          const nextScale =
            this.lbPinchStartScale *
            (
              currentDistance /
              this.lbPinchStartDistance
            );

          this.lbZoomScale =
            this.clampLightboxZoom(
              nextScale,
              this.lbZoomMin,
              this.lbZoomMax
            );

          this.clampLightboxPosition();
          this.applyLightboxZoom();

          return;
        }

        /*
        * Move a zoomed image with one finger.
        */
        if (
          this.lbIsPanning &&
          e.touches.length === 1 &&
          this.lbZoomScale > 1
        ) {
          e.preventDefault();

          const differenceX =
            e.touches[0].clientX -
            this.lbPanStartX;

          const differenceY =
            e.touches[0].clientY -
            this.lbPanStartY;

          this.lbTranslateX =
            this.lbPanOriginX +
            differenceX;

          this.lbTranslateY =
            this.lbPanOriginY +
            differenceY;

          this.clampLightboxPosition();
          this.applyLightboxZoom();
        }
      },
      {
        passive: false
      }
    );

    this.lbTrack.addEventListener(
      'touchend',
      (e) => {
        /*
        * Finish pinch zoom.
        */
        if (this.lbIsPinching) {
          if (
            e.touches.length < 2
          ) {
            this.lbIsPinching = false;

            if (
              this.lbZoomScale < 1.05
            ) {
              this.resetLightboxZoom(
                true
              );
            } else {
              this.clampLightboxPosition();
              this.applyLightboxZoom();
            }
          }

          return;
        }

        /*
        * Finish image panning.
        */
        if (this.lbIsPanning) {
          this.lbIsPanning = false;
          return;
        }

        /*
        * Do not switch slides while zoomed.
        */
        if (
          this.lbZoomScale > 1
        ) {
          return;
        }

        const endX =
          e.changedTouches[0]
            ?.clientX;

        if (
          typeof endX !==
          'number'
        ) {
          return;
        }

        const diff =
          this.lbSwipeStartX -
          endX;

        if (Math.abs(diff) <= 50) {
          return;
        }

        if (this.lbAnimating) {
          return;
        }

        this.lbAnimating = true;

        if (diff > 0) {
          this.lbIndex++;
        } else {
          this.lbIndex--;
        }

        this.updateLightbox();

        setTimeout(() => {
          this.lbAnimating = false;
        }, 300);
      },
      {
        passive: false
      }
    );

    this.lbTrack.addEventListener(
      'touchcancel',
      () => {
        this.lbIsPinching = false;
        this.lbIsPanning = false;
      }
    );
  }
}

/* ==========================================================================
 * LUXE PRODUCT CARD LIGHTBOX
 * ========================================================================== */

class LuxeProductLightbox {
  constructor(lightbox) {
    if (
      lightbox.dataset
        .luxeProductLightboxInitialized
    ) {
      return;
    }

    this.lightbox = lightbox;

    this.sectionRoot =
      lightbox.closest(
        '[id^="shopify-section-"]'
      ) || document;

    this.track =
      lightbox.querySelector(
        '[data-lightbox-track]'
      );

    this.thumbnailsWrap =
      lightbox.querySelector(
        '[data-lightbox-thumbnails]'
      );

    this.prevButton =
      lightbox.querySelector(
        '[data-lightbox-prev]'
      );

    this.nextButton =
      lightbox.querySelector(
        '[data-lightbox-next]'
      );

    this.closeButton =
      lightbox.querySelector(
        '[data-lightbox-close]'
      );

    this.overlay =
      lightbox.querySelector(
        '.pm-lightbox__overlay'
      );

    if (
      !this.track ||
      !this.thumbnailsWrap
    ) {
      return;
    }

    this.products =
      this.getProductsData();

    this.media = [];
    this.slides = [];
    this.thumbnails = [];

    this.count = 0;
    this.index = 1;
    this.animating = false;

    this.loopTimer = null;
    this.resizeTimer = null;

    this.touchStartX = 0;
    this.touchStartY = 0;

    this.pointerStartX = 0;
    this.pointerStartY = 0;
    this.preventCardClick = false;

    this.activeTrigger = null;
    this.previousActiveElement = null;

    this.handleSectionClick =
      this.handleSectionClick.bind(
        this
      );

    this.handlePointerDown =
      this.handlePointerDown.bind(
        this
      );

    this.handlePointerUp =
      this.handlePointerUp.bind(
        this
      );

    this.handleKeydown =
      this.handleKeydown.bind(
        this
      );

    this.handleResize =
      this.handleResize.bind(
        this
      );

    lightbox.dataset
      .luxeProductLightboxInitialized =
      'true';

    this.bindEvents();
  }

  /* ------------------------------------------------------------------------
   * Product data
   * --------------------------------------------------------------------- */

  getProductsData() {
    const jsonId =
      this.lightbox.dataset
        .productsJsonId;

    if (!jsonId) return {};

    const jsonElement =
      document.getElementById(
        jsonId
      );

    if (!jsonElement) return {};

    try {
      return JSON.parse(
        jsonElement.textContent
      );
    } catch (error) {
      console.error(
        'LuxeProductLightbox: invalid product JSON.',
        error
      );

      return {};
    }
  }

  /* ------------------------------------------------------------------------
   * Global events
   * --------------------------------------------------------------------- */

  bindEvents() {
    this.sectionRoot.addEventListener(
      'pointerdown',
      this.handlePointerDown
    );

    this.sectionRoot.addEventListener(
      'pointerup',
      this.handlePointerUp
    );

    this.sectionRoot.addEventListener(
      'click',
      this.handleSectionClick
    );

    this.closeButton?.addEventListener(
      'click',
      () => {
        this.close();
      }
    );

    this.overlay?.addEventListener(
      'click',
      () => {
        this.close();
      }
    );

    this.prevButton?.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        this.prev();
      }
    );

    this.nextButton?.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        this.next();
      }
    );

    this.track.addEventListener(
      'touchstart',
      (event) => {
        this.handleTouchStart(
          event
        );
      },
      {
        passive: true
      }
    );

    this.track.addEventListener(
      'touchend',
      (event) => {
        this.handleTouchEnd(
          event
        );
      },
      {
        passive: true
      }
    );

    document.addEventListener(
      'keydown',
      this.handleKeydown
    );

    window.addEventListener(
      'resize',
      this.handleResize
    );
  }

  /* ------------------------------------------------------------------------
   * Prevent opening after carousel swipe
   * --------------------------------------------------------------------- */

  handlePointerDown(event) {
    const trigger =
      event.target.closest(
        '[data-luxe-product-lightbox-trigger]'
      );

    if (!trigger) return;

    if (
      trigger.dataset.lightboxId !==
      this.lightbox.id
    ) {
      return;
    }

    this.pointerStartX =
      event.clientX;

    this.pointerStartY =
      event.clientY;

    this.preventCardClick = false;
  }

  handlePointerUp(event) {
    const trigger =
      event.target.closest(
        '[data-luxe-product-lightbox-trigger]'
      );

    if (!trigger) return;

    if (
      trigger.dataset.lightboxId !==
      this.lightbox.id
    ) {
      return;
    }

    const distanceX =
      Math.abs(
        event.clientX -
        this.pointerStartX
      );

    const distanceY =
      Math.abs(
        event.clientY -
        this.pointerStartY
      );

    this.preventCardClick =
      distanceX > 8 ||
      distanceY > 8;
  }

  /* ------------------------------------------------------------------------
   * Product card click
   * --------------------------------------------------------------------- */

  handleSectionClick(event) {
    const trigger =
      event.target.closest(
        '[data-luxe-product-lightbox-trigger]'
      );

    if (!trigger) return;

    if (
      trigger.dataset.lightboxId !==
      this.lightbox.id
    ) {
      return;
    }

    if (this.preventCardClick) {
      this.preventCardClick = false;

      event.preventDefault();
      return;
    }

    const ignoredElement =
      event.target.closest(
        [
          'button',
          'input',
          'select',
          'textarea',
          'form',
          '[data-quick-add]',
          '.quick-add',
          '.quick-add__submit',
          '.wishlist',
          '[data-wishlist]',
          '[data-growave-wishlist]'
        ].join(',')
      );

    if (ignoredElement) return;

    const productId =
      trigger.dataset.productId;

    const product =
      this.products[productId];

    if (
      !product ||
      !product.media?.length
    ) {
      return;
    }

    event.preventDefault();

    this.open(
      product,
      trigger
    );
  }

  /* ------------------------------------------------------------------------
   * Open lightbox
   * --------------------------------------------------------------------- */

  open(product, trigger) {
    this.previousActiveElement =
      document.activeElement;

    this.activeTrigger = trigger;
    this.media = product.media;
    this.count = this.media.length;

    this.index =
      this.count > 1
        ? 1
        : 0;

    this.animating = false;

    this.renderSlides();
    this.renderThumbnails();
    this.update(false);

    this.updateNavigation();

    this.lightbox.classList.add(
      'active'
    );

    this.lightbox.setAttribute(
      'aria-hidden',
      'false'
    );

    document.body.classList.add(
      'ov_h'
    );

    this.closeButton?.focus({
      preventScroll: true
    });
  }

  /* ------------------------------------------------------------------------
   * Close lightbox
   * --------------------------------------------------------------------- */

  close() {
    if (
      !this.lightbox.classList.contains(
        'active'
      )
    ) {
      return;
    }

    clearTimeout(
      this.loopTimer
    );

    this.animating = false;

    this.lightbox.classList.remove(
      'active'
    );

    this.lightbox.setAttribute(
      'aria-hidden',
      'true'
    );

    document.body.classList.remove(
      'ov_h'
    );

    this.previousActiveElement?.focus?.({
      preventScroll: true
    });

    this.activeTrigger = null;
    this.previousActiveElement = null;
  }

  /* ------------------------------------------------------------------------
   * Render main slides
   * --------------------------------------------------------------------- */

  renderSlides() {
    this.track.innerHTML = '';

    const realSlides =
      this.media.map(
        (media, index) => {
          const slide =
            document.createElement(
              'div'
            );

          slide.className =
            'pm-lightbox__slide';

          slide.dataset.realIndex =
            String(index + 1);

          const image =
            document.createElement(
              'img'
            );

          image.src = media.src;
          image.alt = media.alt || '';
          image.draggable = false;

          image.loading =
            index === 0
              ? 'eager'
              : 'lazy';

          slide.appendChild(image);

          return slide;
        }
      );

    if (this.count > 1) {
      const firstClone =
        realSlides[0].cloneNode(
          true
        );

      const lastClone =
        realSlides[
          realSlides.length - 1
        ].cloneNode(true);

      firstClone.classList.add(
        'clone'
      );

      lastClone.classList.add(
        'clone'
      );

      firstClone.removeAttribute(
        'data-real-index'
      );

      lastClone.removeAttribute(
        'data-real-index'
      );

      this.track.appendChild(
        lastClone
      );

      realSlides.forEach(
        (slide) => {
          this.track.appendChild(
            slide
          );
        }
      );

      this.track.appendChild(
        firstClone
      );
    } else {
      this.track.appendChild(
        realSlides[0]
      );
    }

    this.slides = Array.from(
      this.track.querySelectorAll(
        '.pm-lightbox__slide'
      )
    );
  }

  /* ------------------------------------------------------------------------
   * Render thumbnails
   * --------------------------------------------------------------------- */

  renderThumbnails() {
    this.thumbnailsWrap.innerHTML =
      '';

    this.media.forEach(
      (media, index) => {
        const button =
          document.createElement(
            'button'
          );

        button.type = 'button';

        button.className =
          'pm-lightbox__thumbnail';

        button.dataset.index =
          String(index + 1);

        button.setAttribute(
          'aria-label',
          `Show image ${index + 1}`
        );

        const image =
          document.createElement(
            'img'
          );

        image.src =
          media.thumbnail ||
          media.src;

        image.alt = '';
        image.loading = 'lazy';
        image.draggable = false;

        button.appendChild(
          image
        );

        button.addEventListener(
          'click',
          () => {
            this.goTo(
              index + 1
            );
          }
        );

        this.thumbnailsWrap.appendChild(
          button
        );
      }
    );

    this.thumbnails = Array.from(
      this.thumbnailsWrap.querySelectorAll(
        '.pm-lightbox__thumbnail'
      )
    );
  }

  /* ------------------------------------------------------------------------
   * Slider navigation
   * --------------------------------------------------------------------- */

  next() {
    if (
      this.animating ||
      this.count <= 1
    ) {
      return;
    }

    this.animating = true;
    this.index++;

    this.update();
  }

  prev() {
    if (
      this.animating ||
      this.count <= 1
    ) {
      return;
    }

    this.animating = true;
    this.index--;

    this.update();
  }

  goTo(index) {
    if (
      this.animating ||
      this.count <= 1 ||
      this.index === index
    ) {
      return;
    }

    this.animating = true;
    this.index = index;

    this.update();
  }

  /* ------------------------------------------------------------------------
   * Slider position
   * --------------------------------------------------------------------- */

  update(animate = true) {
    const position =
      this.count > 1
        ? this.index
        : 0;

    this.track.style.transition =
      animate
        ? 'transform 0.3s ease'
        : 'none';

    this.track.style.transform =
      `translate3d(-${
        position * 100
      }%, 0, 0)`;

    this.updateActiveThumbnail(
      animate
    );

    clearTimeout(
      this.loopTimer
    );

    if (!animate) {
      this.animating = false;
      return;
    }

    this.loopTimer =
      setTimeout(() => {
        this.normalizeIndex();

        this.animating = false;
      }, 300);
  }

  normalizeIndex() {
    if (this.count <= 1) return;

    if (this.index === 0) {
      this.index = this.count;

      this.jump();

      this.updateActiveThumbnail(
        false
      );

      return;
    }

    if (
      this.index ===
      this.count + 1
    ) {
      this.index = 1;

      this.jump();

      this.updateActiveThumbnail(
        false
      );
    }
  }

  jump() {
    const position =
      this.count > 1
        ? this.index
        : 0;

    this.track.style.transition =
      'none';

    this.track.style.transform =
      `translate3d(-${
        position * 100
      }%, 0, 0)`;
  }

  /* ------------------------------------------------------------------------
   * Active thumbnail
   * --------------------------------------------------------------------- */

  getRealIndex() {
    if (this.count <= 1) {
      return 1;
    }

    if (this.index === 0) {
      return this.count;
    }

    if (
      this.index ===
      this.count + 1
    ) {
      return 1;
    }

    return this.index;
  }

  updateActiveThumbnail(
    animate = true
  ) {
    const activeIndex =
      this.getRealIndex();

    this.thumbnails.forEach(
      (thumbnail) => {
        const thumbnailIndex =
          Number(
            thumbnail.dataset.index
          );

        const isActive =
          thumbnailIndex ===
          activeIndex;

        thumbnail.classList.toggle(
          'active',
          isActive
        );

        thumbnail.setAttribute(
          'aria-current',
          isActive
            ? 'true'
            : 'false'
        );
      }
    );

    const activeThumbnail =
      this.thumbnails.find(
        (thumbnail) => {
          return (
            Number(
              thumbnail.dataset.index
            ) === activeIndex
          );
        }
      );

    activeThumbnail?.scrollIntoView({
      behavior: animate
        ? 'smooth'
        : 'auto',
      block: 'nearest',
      inline: 'nearest'
    });
  }

  /* ------------------------------------------------------------------------
   * Navigation visibility
   * --------------------------------------------------------------------- */

  updateNavigation() {
    const hideNavigation =
      this.count <= 1;

    if (this.prevButton) {
      this.prevButton.hidden =
        hideNavigation;
    }

    if (this.nextButton) {
      this.nextButton.hidden =
        hideNavigation;
    }

    this.thumbnailsWrap.hidden =
      hideNavigation;
  }

  /* ------------------------------------------------------------------------
   * Touch swipe
   * --------------------------------------------------------------------- */

  handleTouchStart(event) {
    if (
      event.touches.length !== 1 ||
      this.count <= 1
    ) {
      return;
    }

    this.touchStartX =
      event.touches[0].clientX;

    this.touchStartY =
      event.touches[0].clientY;
  }

  handleTouchEnd(event) {
    if (
      this.count <= 1
    ) {
      return;
    }

    const touch =
      event.changedTouches[0];

    if (!touch) return;

    const distanceX =
      this.touchStartX -
      touch.clientX;

    const distanceY =
      this.touchStartY -
      touch.clientY;

    if (
      Math.abs(distanceX) <= 50 ||
      Math.abs(distanceX) <=
        Math.abs(distanceY)
    ) {
      return;
    }

    if (distanceX > 0) {
      this.next();
    } else {
      this.prev();
    }
  }

  /* ------------------------------------------------------------------------
   * Keyboard and resize
   * --------------------------------------------------------------------- */

  handleKeydown(event) {
    if (
      !this.lightbox.classList.contains(
        'active'
      )
    ) {
      return;
    }

    if (event.key === 'Escape') {
      this.close();
      return;
    }

    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      this.prev();
      return;
    }

    if (
      event.key === 'ArrowRight'
    ) {
      event.preventDefault();
      this.next();
    }
  }

  handleResize() {
    clearTimeout(
      this.resizeTimer
    );

    this.resizeTimer =
      setTimeout(() => {
        if (
          this.lightbox.classList.contains(
            'active'
          )
        ) {
          this.jump();
        }
      }, 150);
  }
}

/* ==========================================================================
 * LUXE PRODUCT CARD LIGHTBOX INITIALIZATION
 * ========================================================================== */

function initLuxeProductLightboxes(
  root = document
) {
  root
    .querySelectorAll(
      '[data-luxe-product-lightbox]'
    )
    .forEach((lightbox) => {
      if (
        lightbox.dataset
          .luxeProductLightboxInitialized
      ) {
        return;
      }

      new LuxeProductLightbox(
        lightbox
      );
    });
}

/* ==========================================================================
 * PRODUCT MOBILE SLIDER INITIALIZATION
 * ========================================================================== */

function initProductMobileSliders() {
  document
    .querySelectorAll('.pm-slider')
    .forEach((el) => {
      if (el.dataset.inited) return;

      el.dataset.inited = 'true';

      new ProductMobileSlider(el);
    });
}

document.addEventListener(
  'DOMContentLoaded',
  initProductMobileSliders
);

window.addEventListener(
  'shopify:section:load',
  initProductMobileSliders
);

/* ==========================================================================
 * PRODUCT CARD SLIDER
 * ========================================================================== */

class ProductCardSlider {
  constructor(slider) {
    if (
      slider.dataset.sliderInitialized
    ) {
      return;
    }

    this.slider = slider;

    this.track =
      slider.querySelector(
        '[data-track]'
      );

    if (!this.track) return;

    this.slides = [
      ...this.track.children
    ];

    if (
      this.slides.length < 2
    ) {
      return;
    }

    slider.dataset.sliderInitialized =
      'true';

    const first =
      this.slides[0].cloneNode(true);

    const last =
      this.slides[
        this.slides.length - 1
      ].cloneNode(true);

    first.classList.add('is-clone');
    last.classList.add('is-clone');

    this.track.insertBefore(
      last,
      this.slides[0]
    );

    this.track.appendChild(first);

    this.count =
      this.slides.length;

    this.index = 1;
    this.animating = false;

    this.prevBtn =
      slider.querySelector(
        '.product-card-slider__arrow--prev'
      );

    this.nextBtn =
      slider.querySelector(
        '.product-card-slider__arrow--next'
      );

    this.jump();
    this.bindEvents();
  }

  /* ------------------------------------------------------------------------
   * Events
   * --------------------------------------------------------------------- */

  bindEvents() {
    this.nextBtn?.addEventListener(
      'click',
      (e) => {
        e.preventDefault();

        if (this.animating) return;

        this.index++;
        this.update();
      }
    );

    this.prevBtn?.addEventListener(
      'click',
      (e) => {
        e.preventDefault();

        if (this.animating) return;

        this.index--;
        this.update();
      }
    );

    let resizeTimer;

    window.addEventListener(
      'resize',
      () => {
        clearTimeout(
          resizeTimer
        );

        resizeTimer =
          setTimeout(() => {
            this.jump();
          }, 150);
      }
    );
  }

  /* ------------------------------------------------------------------------
   * Animated update
   * --------------------------------------------------------------------- */

  update() {
    this.animating = true;

    this.track.style.transition =
      'transform .35s ease';

    this.track.style.transform =
      `translate3d(-${
        this.index * 100
      }%,0,0)`;

    clearTimeout(this.fixTimer);

    this.fixTimer =
      setTimeout(() => {
        if (this.index === 0) {
          this.index =
            this.count;

          this.jump();
        }

        if (
          this.index ===
          this.count + 1
        ) {
          this.index = 1;
          this.jump();
        }

        this.animating = false;
      }, 350);
  }

  /* ------------------------------------------------------------------------
   * Instant update
   * --------------------------------------------------------------------- */

  jump() {
    this.track.style.transition =
      'none';

    this.track.style.transform =
      `translate3d(-${
        this.index * 100
      }%,0,0)`;
  }

  /* ------------------------------------------------------------------------
   * Initialize all sliders
   * --------------------------------------------------------------------- */

  static initAll(
    root = document
  ) {
    root
      .querySelectorAll(
        '[data-slider]'
      )
      .forEach((slider) => {
        new ProductCardSlider(
          slider
        );
      });
  }
}

/* ==========================================================================
 * RELATED PRODUCT SLIDERS
 *
 * LuxeSlider is defined in assets/luxe-slider.js.
 * This function preserves the original __luxeInit flag.
 * ========================================================================== */

function initLuxeSliders(
  root = document
) {
  root
    .querySelectorAll(
      '.luxe-related-products [data-luxe-slider]'
    )
    .forEach((el) => {
      if (el.__luxeInit) return;

      el.__luxeInit = true;

      new LuxeSlider(el);
    });
}

/* ==========================================================================
 * MEGA MENU PARENT LINK
 * ========================================================================== */

document.addEventListener(
  'click',
  (e) => {
    const summary =
      e.target.closest(
        '.mega-menu > summary'
      );

    if (!summary) return;

    e.preventDefault();

    const link = summary
      .closest('details')
      .querySelector(
        '.mega-menu__parent-link'
      );

    if (link) {
      link.click();
    }
  }
);

/* ==========================================================================
 * PRODUCT CONDITION TOOLTIP
 * ========================================================================== */

document.addEventListener(
  'click',
  function (e) {
    const trigger =
      e.target.closest(
        '.luxe-tooltip-pdp-js'
      );

    if (!trigger) {
      document
        .querySelectorAll(
          '.luxe-condition--item.active'
        )
        .forEach((item) => {
          item.classList.remove(
            'active'
          );
        });

      return;
    }

    const value =
      trigger.dataset.condition.trim();

    trigger
      .querySelectorAll(
        '.luxe-condition--item'
      )
      .forEach((item) => {
        item.classList.remove(
          'active'
        );
      });

    const currentItem =
      trigger.querySelector(
        `.luxe-condition--item[data-item="${CSS.escape(
          value
        )}"]`
      );

    if (currentItem) {
      currentItem.classList.toggle(
        'active'
      );
    }
  }
);

/* ==========================================================================
 * CUSTOM FILTER BUTTONS
 * ========================================================================== */

function insertButtons() {
  const trigger =
    document.querySelector(
      '.gf-filter-trigger'
    );

  if (
    !trigger ||
    document.querySelector(
      '.custom-filter-buttons'
    )
  ) {
    return;
  }

  trigger.insertAdjacentHTML(
    'afterend',
    `
      <div class="custom-filter-buttons">
        <button
          type="button"
          class="custom-filter-btn"
          data-filter="categories"
        >
          Categories
        </button>

        <button
          type="button"
          class="custom-filter-btn"
          data-filter="designers"
        >
          Designers
        </button>

        <button
          type="button"
          class="custom-filter-btn"
          data-filter="condition"
        >
          Condition
        </button>
      </div>
    `
  );
}

/* ==========================================================================
 * CUSTOM FILTER BUTTON STATE
 * ========================================================================== */

function syncParentChildFilterOptions(button) {
  const optionItem = button.closest('li');

  if (!optionItem) return;

  const childButtons = Array.from(
    optionItem.querySelectorAll('button[aria-label]')
  ).filter((childButton) => {
    return (
      childButton !== button &&
      childButton.closest('li') !== optionItem
    );
  });
console.log("item count SSSSSS " )
  if (!childButtons.length) return;

  const shouldCheck = button.getAttribute('aria-checked') === 'false';

  childButtons.forEach((childButton) => {
    if (childButton.dataset.luxeSyncing === 'true') {
      return;
    }

    const isChecked = childButton.getAttribute('aria-checked') === 'true';

    if (isChecked === shouldCheck) {
      return;
    }

    childButton.dataset.luxeSyncing = 'true';
    childButton.click();
    delete childButton.dataset.luxeSyncing;
  });
}

document.addEventListener('click', (e) => {
  const button = e.target.closest(
    '.gf-option-box button[aria-label]'
  );

  if (!button || button.dataset.luxeSyncing === 'true') {
    return;
  }

  const optionItem = button.closest('li');

  if (!optionItem) return;

  const childButtons = Array.from(
    optionItem.querySelectorAll('button[aria-label]')
  ).filter((childButton) => {
    return (
      childButton !== button &&
      childButton.closest('li') !== optionItem
    );
  });

  if (!childButtons.length) return;

  syncParentChildFilterOptions(button);
});

function updateCustomButtons() {
  document
    .querySelectorAll(
      '.custom-filter-btn'
    )
    .forEach((btn) => {
      const block = [
        ...document.querySelectorAll(
          '.gf-filter-contents [data-filter-type]'
        )
      ].find((el) => {
        return (
          el
            .querySelector(
              '.h3 span'
            )
            ?.textContent
            .trim()
            .toLowerCase() ===
          btn.dataset.filter
            .toLowerCase()
        );
      });

      if (!block) return;

      const checkedCount =
        block.querySelectorAll(
          '.gf-option-box ' +
          'button[aria-label]' +
          '[aria-checked="true"]'
        ).length;

      btn.classList.toggle(
        'is-active',
        checkedCount > 0
      );

      if (checkedCount > 0) {
        btn.dataset.val =
          checkedCount;
      } else {
        delete btn.dataset.val;
      }
    });
}

/* ==========================================================================
 * MOVE CLEAR ALL BUTTON
 * ========================================================================== */

function moveClearAllButton() {
  const footer =
    document.querySelector(
      '.gf-filter-footer'
    );

  const clearBtn =
    document.querySelector(
      '.globo-selected-items-wrapper ' +
      '.gf-refine-toggle'
    );

  if (
    !footer ||
    !clearBtn
  ) {
    return;
  }

  if (
    footer.contains(clearBtn)
  ) {
    return;
  }

  footer.prepend(clearBtn);
}

/* ==========================================================================
 * SELECTED VALUES IN FILTER TITLES
 * ========================================================================== */

function updateFilterTitles() {
  document
    .querySelectorAll(
      '.gf-option-block'
    )
    .forEach((block) => {
      const title =
        block.querySelector(
          '.gf-block-title'
        );

      if (!title) return;

      const selected = [
        ...block.querySelectorAll(
          '.gf-option-box ' +
          'button[aria-checked="true"] ' +
          '.gf-label'
        )
      ].map((el) => {
        return el.textContent.trim();
      });

      let badge =
        title.querySelector(
          '.gf-selected-values'
        );

      if (!selected.length) {
        badge?.remove();
        return;
      }

      if (!badge) {
        badge =
          document.createElement(
            'span'
          );

        badge.className =
          'gf-selected-values';

        const h3 =
          title.querySelector(
            '.h3 span'
          );

        h3.insertAdjacentElement(
          'afterend',
          badge
        );
      }

      const selectedText =
        selected.join(', ');

      if (
        badge.textContent !==
        selectedText
      ) {
        badge.textContent =
          selectedText;
      }
    });
}

/* ==========================================================================
 * SELECTED MINIMUM PRICE IN FILTER TITLE
 * ========================================================================== */

function parseGloboPrice(value) {
  if (value === null || value === undefined) {
    return null;
  }

  const normalizedValue =
    String(value)
      .replace(/[^0-9.-]/g, '');

  const numberValue =
    Number(normalizedValue);

  return Number.isFinite(numberValue)
    ? numberValue
    : null;
}

function formatGloboPrice(value) {
  const currency =
    window.Shopify?.currency?.active ||
    'USD';

  const locale =
    document.documentElement.lang ||
    'en';

  return new Intl.NumberFormat(
    locale,
    {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }
  ).format(value);
}

function updatePriceFilterTitle() {
  document
    .querySelectorAll(
      '[data-filter-type="Price"]'
    )
    .forEach((priceBlock) => {
      const title =
        priceBlock.querySelector(
          '.gf-block-title .h3'
        );

      const titleText =
        title?.querySelector(
          ':scope > span'
        );

      const minInput =
        priceBlock.querySelector(
          '.gf-range-min'
        );

      if (
        !title ||
        !titleText ||
        !minInput
      ) {
        return;
      }

      const absoluteMin =
        parseGloboPrice(
          minInput.dataset.minValue
        );

      const selectedMin =
        parseGloboPrice(
          minInput.value
        );

      let badge =
        title.querySelector(
          '.gf-price-selected'
        );

      const hasSelectedMinimum =
        absoluteMin !== null &&
        selectedMin !== null &&
        selectedMin > absoluteMin;

      if (!hasSelectedMinimum) {
        badge?.remove();
        return;
      }

      if (!badge) {
        badge =
          document.createElement(
            'span'
          );

        badge.className =
          'gf-price-selected';

        titleText.insertAdjacentElement(
          'afterend',
          badge
        );
      }

      const nextText =
        `> ${formatGloboPrice(
          selectedMin
        )}`;

      if (
        badge.textContent !== nextText
      ) {
        badge.textContent =
          nextText;
      }
    });
}

/* ==========================================================================
 * PRICE RANGE LAYOUT
 * ========================================================================== */

function updatePriceRangeLayout() {
  document
    .querySelectorAll(
      '[data-filter-type="Price"]'
    )
    .forEach((priceBlock) => {
      const rangeInputs =
        priceBlock.querySelector(
          '.gf-range-inputs'
        );

      const minInput =
        priceBlock.querySelector(
          '.gf-range-min'
        );

      const maxInput =
        priceBlock.querySelector(
          '.gf-range-max'
        );

      if (
        !rangeInputs ||
        !minInput ||
        !maxInput
      ) {
        return;
      }

      const absoluteMin =
        parseGloboPrice(
          minInput.dataset.minValue
        );

      const absoluteMax =
        parseGloboPrice(
          maxInput.dataset.maxValue
        );

      minInput.placeholder = 'Min';
      maxInput.placeholder = 'Max';

      let fromLabel =
        rangeInputs.querySelector(
          '.gf-price-label--min'
        );

      let toLabel =
        rangeInputs.querySelector(
          '.gf-price-label--max'
        );

      let minValue =
        rangeInputs.querySelector(
          '.gf-price-limit--min'
        );

      let maxValue =
        rangeInputs.querySelector(
          '.gf-price-limit--max'
        );

      if (!fromLabel) {
        fromLabel =
          document.createElement(
            'span'
          );

        fromLabel.className =
          'gf-price-label ' +
          'gf-price-label--min';

        fromLabel.textContent =
          'From';

        rangeInputs.appendChild(
          fromLabel
        );
      }

      if (!toLabel) {
        toLabel =
          document.createElement(
            'span'
          );

        toLabel.className =
          'gf-price-label ' +
          'gf-price-label--max';

        toLabel.textContent =
          'To';

        rangeInputs.appendChild(
          toLabel
        );
      }

      if (!minValue) {
        minValue =
          document.createElement(
            'span'
          );

        minValue.className =
          'gf-price-limit ' +
          'gf-price-limit--min';

        rangeInputs.appendChild(
          minValue
        );
      }

      if (!maxValue) {
        maxValue =
          document.createElement(
            'span'
          );

        maxValue.className =
          'gf-price-limit ' +
          'gf-price-limit--max';

        rangeInputs.appendChild(
          maxValue
        );
      }

      const minText =
        absoluteMin !== null
          ? formatGloboPrice(
              absoluteMin
            )
          : '';

      const maxText =
        absoluteMax !== null
          ? formatGloboPrice(
              absoluteMax
            )
          : '';

      if (
        minValue.textContent !==
        minText
      ) {
        minValue.textContent =
          minText;
      }

      if (
        maxValue.textContent !==
        maxText
      ) {
        maxValue.textContent =
          maxText;
      }
    });
}

/* ------------------------------------------------------------------------
 * Price input events
 * --------------------------------------------------------------------- */

document.addEventListener(
  'input',
  (e) => {
    if (
      !e.target.matches(
        '[data-filter-type="Price"] .gf-range-min'
      )
    ) {
      return;
    }

    updatePriceFilterTitle();
  }
);

document.addEventListener(
  'change',
  (e) => {
    if (
      !e.target.matches(
        '[data-filter-type="Price"] .gf-range-min'
      )
    ) {
      return;
    }

    updatePriceFilterTitle();
  }
);

/* ------------------------------------------------------------------------
 * Globo price slider events
 * --------------------------------------------------------------------- */

function bindPriceSliderEvents() {
  document
    .querySelectorAll(
      '[data-filter-type="Price"] .gf-range-slider'
    )
    .forEach((slider) => {
      if (
        slider.__luxePriceTitleBound
      ) {
        return;
      }

      if (!slider.noUiSlider) {
        return;
      }

      slider.__luxePriceTitleBound =
        true;

      slider.noUiSlider.on(
        'update.luxePriceTitle',
        () => {
          updatePriceFilterTitle();
        }
      );
    });
}

/* ==========================================================================
 * CUSTOM FILTER BUTTON CLICK
 * ========================================================================== */

document.addEventListener(
  'click',
  (e) => {
    const btn =
      e.target.closest(
        '.custom-filter-btn'
      );

    if (!btn) return;

    document
      .querySelector(
        '.gf-filter-trigger button'
      )
      ?.click();

    setTimeout(() => {
      const blocks = [
        ...document.querySelectorAll(
          '.gf-filter-contents [data-filter-type]'
        )
      ];

      const customFilters = [
        'categories',
        'designers',
        'condition'
      ];

      blocks.forEach(
        (block) => {
          const title =
            block.querySelector(
              '.h3'
            );

          const name = title
            ?.querySelector('span')
            ?.textContent
            .trim()
            .toLowerCase();

          if (
            customFilters.includes(
              name
            ) &&
            title?.getAttribute(
              'aria-expanded'
            ) === 'true'
          ) {
            title.click();
          }
        }
      );

      const block =
        blocks.find(
          (block) => {
            const name = block
              .querySelector(
                '.h3 span'
              )
              ?.textContent
              .trim()
              .toLowerCase();

            return (
              name ===
              btn.dataset.filter
                .toLowerCase()
            );
          }
        );

      if (!block) return;

      const title =
        block.querySelector('.h3');

      if (
        title?.getAttribute(
          'aria-expanded'
        ) === 'false'
      ) {
        title.click();
      }

      block.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }, 300);
  }
);

/* ==========================================================================
 * MOVE FILTER SUMMARY
 * ========================================================================== */

function moveSummary() {
  const summary =
    document.querySelector(
      '.gf-summary'
    );

  const searchForm =
    document.querySelector(
      '.gf-controls-search-form'
    );

  if (
    !summary ||
    !searchForm
  ) {
    return;
  }

  if (
    searchForm.nextElementSibling ===
    summary
  ) {
    return;
  }

  searchForm.insertAdjacentElement(
    'afterend',
    summary
  );
}

/* ==========================================================================
 * FILTER COLOUR MAP
 * ========================================================================== */

const colourMap = {
  black: {
    color: '#000000'
  },

  brown: {
    color: '#6B3E26'
  },

  burgundy: {
    color: '#8B0029'
  },

  red: {
    color: '#D50000'
  },

  blue: {
    color: '#1D21C9'
  },

  purple: {
    color: '#7A0A8A'
  },

  pink: {
    color: '#F77F95'
  },

  orange: {
    color: '#FF9800'
  },

  green: {
    color: '#1B8F1F'
  },

  grey: {
    color: '#8C8C8C'
  },

  yellow: {
    color: '#FFD944'
  },

  white: {
    color: '#F8F8F8',
    border: '#CFCFCF'
  },

  beige: {
    color: '#F5F5DC'
  },

  camel: {
    color: '#C19A6B'
  },

  taupe: {
    color: '#483C32'
  },

  off_white: {
    color: '#FAF9F6'
  },

  neutrals: {
    color: '#F4EEDD'
  },

  metallic: {
    image:
      'https://cdn.shopify.com/s/files/1/0984/3834/9182/files/Metallic.svg?v=1782799933'
  },

  gold: {
    image:
      'https://cdn.shopify.com/s/files/1/0984/3834/9182/files/Gold.svg?v=1782799933'
  },

  silver: {
    image:
      'https://cdn.shopify.com/s/files/1/0984/3834/9182/files/Silver.svg?v=1782799933'
  },

  clear: {
    image:
      'https://cdn.shopify.com/s/files/1/0984/3834/9182/files/Clear.svg?v=1782799933'
  },

  'pattern-prints': {
    image:
      'https://cdn.shopify.com/s/files/1/0984/3834/9182/files/Pattern_Prints.png?v=1782799933'
  },

  'animal-print': {
    image:
      'https://cdn.shopify.com/s/files/1/0984/3834/9182/files/Animal_Print.png?v=1782741824'
  }
};

/* ==========================================================================
 * FILTER COLOUR LABELS
 * ========================================================================== */

function initColourLabels() {
  document
    .querySelectorAll(
      '[data-fvalue^="colour:"]'
    )
    .forEach((button) => {
      if (
        button.dataset.colourInit ===
        'true'
      ) {
        return;
      }

      button.dataset.colourInit =
        'true';

      const colour =
        button.dataset.fvalue.replace(
          'colour:',
          ''
        );

      const label =
        button.querySelector(
          '.gf-label'
        );

      if (!label) return;

      label.dataset.colour =
        colour;

      label.textContent =
        colour.replaceAll(
          '-',
          ' '
        );

      let swatch =
        label.previousElementSibling;

      if (
        !swatch ||
        !swatch.classList.contains(
          'gf-colour-swatch'
        )
      ) {
        swatch =
          document.createElement(
            'span'
          );

        swatch.className =
          'gf-colour-swatch';

        label.before(swatch);
      }

      const value =
        colourMap[colour];

      swatch.style.background =
        '';

      swatch.style.backgroundImage =
        '';

      if (value?.image) {
        swatch.style.backgroundImage =
          `url(${value.image})`;

        swatch.style.backgroundSize =
          'cover';

        swatch.style.backgroundPosition =
          'center';
      } else if (value?.color) {
        swatch.style.background =
          value.color;
      } else {
        swatch.style.background =
          colour;
      }
    });
}

/* ==========================================================================
 * DYNAMIC DOM UPDATES
 *
 * The original file had three MutationObserver instances:
 *
 * 1. insertButtons()
 * 2. moveSummary()
 * 3. slider and filter updates through requestAnimationFrame()
 *
 * This function preserves that order.
 * ========================================================================== */

function runDynamicUpdates() {
  /*
   * LuxeSlider lives in assets/luxe-slider.js.
   *
   * The check prevents this file from stopping if
   * luxe-slider.js has not finished loading yet.
   */
  if (
    typeof LuxeSlider ===
    'function'
  ) {
    initLuxeSliders();
  }

  ProductCardSlider.initAll();
  initLuxeProductLightboxes();

  updateCustomButtons();
  updateFilterTitles();
  
  updatePriceFilterTitle();
  updatePriceRangeLayout();
  bindPriceSliderEvents();

  moveClearAllButton();
  initColourLabels();
}

/* ==========================================================================
 * SINGLE GLOBAL MUTATION OBSERVER
 * ========================================================================== */

let scheduled = false;

function scheduleDynamicUpdates() {
  if (scheduled) return;

  scheduled = true;

  requestAnimationFrame(() => {
    scheduled = false;

    runDynamicUpdates();
  });
}

const observer =
  new MutationObserver(() => {
    /*
     * These two functions were previously called
     * by their own synchronous observer callbacks.
     */
    insertButtons();
    moveSummary();

    /*
     * Heavier updates remain grouped into one frame,
     * exactly like the original main observer.
     */
    scheduleDynamicUpdates();
  });

/* ==========================================================================
 * INITIALIZATION
 * ========================================================================== */

function initLuxeCommon() {
  /*
   * Start observing before the initial DOM updates.
   * This lets the observer see elements inserted or
   * moved by insertButtons() and moveSummary().
   */
  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );

  /*
   * Preserve the original immediate calls.
   */
  insertButtons();
  moveSummary();

  /*
   * Initialize content already present on the page.
   */
  scheduleDynamicUpdates();
}

if (
  document.readyState ===
  'loading'
) {
  document.addEventListener(
    'DOMContentLoaded',
    initLuxeCommon,
    { once: true }
  );
} else {
  initLuxeCommon();
}

/* ==========================================================================
 * SHOPIFY THEME EDITOR
 * ========================================================================== */

window.addEventListener(
  'shopify:section:load',
  () => {
    insertButtons();
    moveSummary();
    scheduleDynamicUpdates();
  }
);